import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, ArrowLeft, Search, MapPin } from "lucide-react";
import { t } from "i18next";

const NotFound = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleGoHome = () => {
        navigate("/");
    };

    const currentPath = location.pathname;

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-4">
            <div className="max-w-2xl w-full text-center">
                {/* 404 Illustration */}
                <div className="mb-8">
                    <div className="inline-flex items-center justify-center w-32 h-32 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full mb-6">
                        <span className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                            404
                        </span>
                    </div>

                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                        {t('pageNotFound')}
                    </h1>

                    <p className="text-xl text-gray-600 mb-2">
                        {t('pageNotExist')}
                    </p>

                    <div className="inline-flex items-center px-4 py-2 bg-gray-100 rounded-lg text-sm text-gray-500 font-mono">
                        <MapPin className="w-4 h-4 mr-2" />
                        {currentPath}
                    </div>
                </div>

                {/* Error Card */}
                <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8 mb-8">
                    <div className="mb-6">
                        <h3 className="text-lg font-semibold text-gray-900 mb-3">
                           {t('whatYouCanDo')}
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
                            <div className="flex items-start space-x-3">
                                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                                    <Search className="w-4 h-4 text-blue-600" />
                                </div>
                                <div>
                                    <h4 className="font-medium text-gray-900">{t('checkUrl')}</h4>
                                    <p className="text-sm text-gray-600">{t('isAddressCorrect')}</p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-3">
                                <div className="flex-shrink-0 w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
                                    <Home className="w-4 h-4 text-green-600" />
                                </div>
                                <div>
                                    <h4 className="font-medium text-gray-900">{t('visitHomepage')}</h4>
                                    <p className="text-sm text-gray-600">{t('startOver')}</p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-3">
                                <div className="flex-shrink-0 w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
                                    <ArrowLeft className="w-4 h-4 text-purple-600" />
                                </div>
                                <div>
                                    <h4 className="font-medium text-gray-900">{t('goBack')}</h4>
                                    <p className="text-sm text-gray-600">{t('returnToPreviousPage')}</p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-3">
                                <div className="flex-shrink-0 w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
                                    <span className="text-orange-600 font-bold text-sm">?</span>
                                </div>
                                <div>
                                    <h4 className="font-medium text-gray-900">{t('getHelp')}</h4>
                                    <p className="text-sm text-gray-600">{t('contactSupport')}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <button
                            onClick={handleGoHome}
                            className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transform hover:scale-105"
                        >
                            <Home className="w-4 h-4 mr-2" />
                            {t('goToHomepage')}
                        </button>

                        <button
                            onClick={handleGoBack}
                            className="inline-flex items-center justify-center px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                        >
                            <ArrowLeft className="w-4 h-4 mr-2" />
                            {t('goBack')}
                        </button>
                    </div>
                </div>

                {/* Help Text */}
                {/* <p className="text-sm text-gray-500">
                    If you think this is a mistake, please{" "}
                    <button
                        className="text-blue-600 hover:text-blue-700 underline focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded"
                        onClick={() => window.location.href = 'mailto:subodh@abcd.com'}
                    >
                        contact our support team
                    </button>
                    .
                </p> */}
            </div>
        </div>
    );
};

export default NotFound;